import type { ArtShortSerializer, IApiResponse } from "@litres-libs/types";

import isEqual from "lodash/isEqual";
import { rtkqApi } from "../api/rtkqApi";
import type { IArtsFacetsRequest } from "../../types/api";
import { TagsType } from "../constants";

export enum EArtGroup {
  ALL = 0,
  TEXT = 1,
  AUDIO = 2,
  PODCAST = 10,
  PODCAST_EPISODE = 11,
}

export interface ILibraryArtsFacetsRequest extends IArtsFacetsRequest {
  library_ids?: number[];
  my_libraries_arts_filter?: string;
  art_groups?: EArtGroup[];
  limit?: number;
  after?: string;
}

export const libraryApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getLibraryArts: build.query<
      IApiResponse<ArtShortSerializer[]>["payload"],
      ILibraryArtsFacetsRequest
    >({
      query: ({
        library_ids,
        my_libraries_arts_filter,
        art_groups,
        limit,
        after,
      }) => ({
        method: "GET",
        url: "/foundation/api/users/me/libraries/arts",
        params: {
          library_ids,
          my_libraries_arts_filter,
          art_groups,
          limit,
          after,
        },
      }),
      transformResponse: (response: IApiResponse<ArtShortSerializer[]>) => {
        return response.payload;
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const { after: _after, ...rest } = queryArgs;
        return `${endpointName}_${JSON.stringify(rest)}`;
      },
      merge: (currentCache, newResponse, { arg }) => {
        if (arg.after) {
          const newData = newResponse.data.filter(
            item => !currentCache.data.find(current => current.id === item.id)
          );
          currentCache.data.push(...newData);
        } else {
          currentCache.data = newResponse.data;
        }

        currentCache.pagination = newResponse.pagination;
      },
      forceRefetch({ currentArg, previousArg }) {
        return !isEqual(currentArg, previousArg);
      },
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
  }),
});
